import state from './organization.state'
import mutations from './organization.mutations'
import actions from './organization.actions'

export default {
  state,
  mutations,
  actions
}
